module.exports = __webpack_public_path__ + "static/LI-Logo-c24cde2827448f08d40afd6909011e16.png";